import './App.css';

import { Navbar, Screenshot } from './components';
import { Features, Footer, Header, Pricing } from './containers';

function App() {
  return (
    <div className="App">
      <div className="background__top">
        <Navbar />
        <Header />
      </div>
      <Features />
      <Screenshot />
      <div className="background__bottom">
        <Pricing />
        <Footer />
      </div>
    </div>
  );
}

export default App;
